<template>
  <div sytle="display:inline-block;">
<!--    ->{{value}}<- -->
<!--    =={{address.value3}}==-->
    <a-select placeholder="省" style="width: 30%;margin-right: 4%" v-model="address.value1"
              @change="(val)=>{getAddressList(val,'list2',['value2','value3'])}">
      <a-select-option :value="item.regionCode" v-for="(item,index) in address.list1">{{item.regionName}}</a-select-option>
    </a-select>
    <a-select placeholder="市" style="width: 30%;margin-right: 4%" v-model="address.value2"
              @change="(val)=>{getAddressList(val,'list3','value3')}">
      <a-select-option :value="item.regionCode" v-for="(item,index) in address.list2">{{item.regionName}}</a-select-option>
    </a-select>
    <a-select placeholder="区/县" style="width: 31%"  v-model="address.value3" @change="chooseOk">
      <a-select-option :value="item.regionCode" v-for="(item,index) in address.list3">{{item.regionName}}</a-select-option>
    </a-select>
  </div>
</template>
<script >
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
import { addressgetByRegionCode, addresslist } from '@api/api'

export default {
  name: "shengshixian",
  mixins: [JeecgListMixin, mixinDevice],
  data () {
    return {
      address: {
        list1: [],
        value1: '',
        list2: [],
        value2: '',
        list3: [],
        value3: ''
      }
    }
  },
  props: {
    value:String
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.address.value3 = val;
          this.getAll();
        }
      }
    }
  },
  async created(){
    await this.getAddressList('100000','list1')
    this.getAll()
  },
  methods:{
    chooseOk(){
      this.$emit('input',this.address.value3)
      this.$emit('change', this.address.value3)
    },
    getAll(){
      addressgetByRegionCode({regionCode:this.value}).then(res=>{
        this.address.value1 = res.result.provincialCode
        this.address.value2 = res.result.municipalCode
        this.address.value3 = res.result.districtCode
        this.getAddressList(this.address.value1,'list2')
        this.getAddressList(this.address.value2,'list3')
      })
    },
    async getAddressList(code,name,value){
      let res = await addresslist({ parentCode: code, })
      this.address[name] = res.result
      if(value){
        if(Array.isArray(value)){
          value.forEach(v=>{
            this.address[v] = ''
          })
        }else{
          this.address[value] = ''
        }
      }
    },
  }
}
</script>

<style scoped>

</style>